export const START_NODE_ID = 'start-node-0';
export const TRAILING_NODE_ID = 'trailing-node-1';
